export default "__VITE_ASSET__617a4b13__"